import qrcode from 'qrcode-generator';

/**
 * La matrice d'un code QR : `true` pour un module noir.
 *
 * <p>Le générateur écrit à la main ici donnait des codes que personne ne
 * lisait (somme de contrôle fausse, refusée même pour « HELLO ») : l'aperçu
 * de l'offre et de la facture, l'impression depuis l'écran et la page du
 * client montraient un QR-facture impossible à payer. Le PDF envoyé, lui,
 * prend le QR du serveur. Un générateur éprouvé (qrcode-generator, MIT)
 * le remplace : niveau de correction M et octets UTF-8, comme le demande la
 * QR-facture suisse.
 *
 * @param {string} texte le contenu du code
 * @returns {boolean[][]} les modules, ligne par ligne
 * @throws {Error} si le contenu ne tient pas dans un code QR
 */
export function qrMatrix(texte) {
  const qr = qrcode(0, 'M');
  const avant = qrcode.stringToBytes;
  qrcode.stringToBytes = qrcode.stringToBytesFuncs['UTF-8'];
  try {
    // Mode octets, celui par défaut du générateur.
    qr.addData(String(texte));
    qr.make();
  } finally {
    qrcode.stringToBytes = avant;
  }
  const n = qr.getModuleCount();
  const m = [];
  for (let y = 0; y < n; y++) {
    const ligne = [];
    for (let x = 0; x < n; x++) ligne.push(qr.isDark(y, x));
    m.push(ligne);
  }
  return m;
}
